import { render, staticRenderFns } from "./programAdd.vue?vue&type=template&id=53fbebf2&"
import script from "./programAdd.vue?vue&type=script&lang=js&"
export * from "./programAdd.vue?vue&type=script&lang=js&"
import style0 from "./programAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports